<template>
	<div class="vstack gap-6">
		<div class="vstack gap-1">
			<h3>Accesos directos</h3>
			<p class="text-body-secondary lh-sm">Todo lo que necesitas para empezar a usar la plataforma de forma rápida y eficiente.</p>
		</div>
		<div class="row g-3 row-cols-2 row-cols-lg-3 g-base">
			<CompanyCommonShortcutLink icon="briefcase" title="Clientes" description="De la empresa" :link="{ name: 'company.admin.customer.index' }" v-if="company.pivot.roles.includes('admin')" />
			<CompanyCommonShortcutLink icon="check-square" title="Asignar clientes" description="A los vendedores" :link="{ name: 'company.leader.customer.index' }" v-if="company.pivot.roles.includes('leader')" />
			<CompanyCommonShortcutLink icon="receipt" title="Ventas" description="Registradas" :link="{ name: 'company.admin.sale.index' }" v-if="company.pivot.roles.includes('admin')" />
			<CompanyCommonShortcutLink icon="people" title="Usuarios" description="Con acceso" :link="{ name: 'company.admin.user.index' }" v-if="company.pivot.roles.includes('admin')" />
			<CompanyCommonShortcutLink icon="coin" title="Balances" description="De vendedores" :link="{ name: 'company.admin.balance.index' }" v-if="company.pivot.roles.includes('admin')" />
			<CompanyCommonShortcutLink icon="plug" title="Conexiones" description="Con plataformas" :link="{ name: 'company.admin.synchronizer.index' }" v-if="company.pivot.roles.includes('admin')" />
			<CompanyCommonShortcutLink icon="flag" title="Metas" description="De los vendedores" :link="{ name: 'company.admin.goal.index' }" v-if="company.pivot.roles.includes('admin')" />
			<CompanyCommonShortcutLink icon="graph-up" title="Estadísticas" description="Generales" :link="{ name: 'company.admin.report.general' }" v-if="company.pivot.roles.includes('admin')" />
			<CompanyCommonShortcutLink icon="building" title="Perfil" description="De la empresa" :link="{ name: 'company.admin.setting.index' }" v-if="company.pivot.roles.includes('admin')" />
		</div>
	</div>
</template>

<script>
	import { computed } from 'vue';
	import store from '@/store';

	export default {
		setup() {
			const company = computed(() => store.getters['company/info']);

			return { company };
		}
	}
</script>